import React from 'react';
import { Typography } from '@metarouter-private/mr-mui';

const DERIVED_NOTE_TEXT = 'Previous values are inferred from the preceding audit entry for this record.';

export default function AuditLogDerivedNote() {
  return (
    <Typography data-test-id="auditLogDerivedNote" variant="caption" color="text.secondary">
      {DERIVED_NOTE_TEXT}
    </Typography>
  );
}
